import {
	sendThirdPartyNudge,
	type Collaborators,
} from '@atlassian/confluence-cross-join-third-party-nudges';

import { getFeatureVisitedCount } from './feature-visited';
import { getExperimentAnalytics } from './analytics';
import type { CrossJoinNudgesInput } from './run-cross-join-third-party-nudges';

type SendNudgeInput = Pick<CrossJoinNudgesInput, 'createAnalyticsEvent' | 'cloudId'> & {
	userId: string;
	collaborators: Collaborators;
	accessCapability: 'DIRECT_ACCESS' | 'REQUEST_ACCESS';
};

export const sendNudge = async ({
	userId,
	cloudId,
	collaborators,
	accessCapability,
	createAnalyticsEvent,
}: SendNudgeInput) => {
	const featureVisitedCount = getFeatureVisitedCount();
	const attributes = {
		collaborators: collaborators.length,
		userId,
		cloudId,
		featureVisitedCount,
		accessCapability,
	};
	const analytics = getExperimentAnalytics(createAnalyticsEvent, {
		attributes,
	});
	await sendThirdPartyNudge(featureVisitedCount, collaborators, accessCapability);
	analytics('sendTrackEvent', 'thirdPartyNudge', 'send', undefined, attributes);
};
